<input [placeholder]="placeHolder" [formControl]="searchField">
